<div class="post-cards-tools {{ toolsClass }}">
  <div
    class="items-per-page"
    *ngIf="
      userFacade.hasPermissionSync(
        AppComponents.FEED_SEARCH_RESULTS_ITEMS_PER_PAGE
      )
    "
  >
    <sui-select
      *ngIf="itemsPerPage$ | async as itemsPerPage"
      [ngModel]="itemsPerPage"
      (ngModelChange)="onItemsPerPageChange($event)"
    >
      <sui-select-option
        *ngFor="let option of itemsPerPageOptions"
        [value]="option"
        >{{ option }}</sui-select-option
      >
    </sui-select>

    <div class="total-count">
      from
      <span class="bold">{{ totalItemsCount$ | async | number }}</span>
      total
    </div>
  </div>
  <div class="pagination-holder" *ngIf="paginationData$ | async as data">
    <sui-pagination
      [pageSize]="data.pageSize"
      [currentPage]="data.page"
      [collectionSize]="data.collectionSize"
      (pageChanged)="pageChanged($event)"
      (doPageChange)="doPageChange($event)"
    ></sui-pagination>
  </div>
</div>
